import { axiosAccess, axiosDocument, axiosROW } from "@config/axiosConfig";
import { PreviewROWPayload, UploadedDocumentsPayload } from "../../types";

export const previewROWResponse = async (payload: PreviewROWPayload) => {
  const { access_id } = payload;
  return await axiosROW.get(
    `/rowApplicationDetailsOnPreview/?applicationId=${access_id}`,
    {}
  );
};

export const uploadedDocuments = async (payload: any) => {
  const { access_id, module_type, category_id } = payload;
  return await axiosDocument.get(
    `/uploaded-files/${access_id}?application_type_id=${
      category_id
    }&module_type=${module_type}`,
    {}
  );
};
